import React, { useEffect, useState } from 'react'
import AdminBreadcrumb from '../Common/AdminBreadcrumb';
import { Link, useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { GetPages, DeleteGallery } from '../../../API/admin'
import Loader from '../Common/Loader';
import Swal from 'sweetalert2'
import {
    CButton,
    CCard,
    CCardBody,
    CCol,
    CRow,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CModalFooter
} from '@coreui/react'

const Faq = () => {
    // Manage AdminBreadcrumb
    const adminBreadcrumbLinks = [
        { label: 'Dashboard', to: '/admin/dashboard', active: false },
        { label: 'Gallery', to: '/list-Gallery', active: true },
    ];

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const Navigate = useNavigate();
    let [loaderStatus, setloaderStatus] = useState(true)
    let [pages, setPages] = useState([])
    // let [pageBody, setPageBody] = useState([])
    useEffect(() => {
        getPagesAPI()
    }, [])

    let getPagesAPI = async () => {
        let res = await GetPages()
        console.log(res.data)
        if (res.status) {
            setPages(res.data);
        } else {
            setPages([]);
        }
    }

    function truncateText(text, maxWords) {
        const words = text.split(' ');
        if (words.length > maxWords) {
            return words.slice(0, maxWords).join(' ') + '...';
        }
        return text;
    }
    function stripHtml(html) {
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent || div.innerText || "";
    }
    // const HandelChange = (event) => {
    //     // event.preventDefault;
    //     // console.log(event.target.value);
    //     let search = event.target.value;
    //     // console.log("yes");
    //     // let usersarr = Users;
    //     const subArr = alluser.filter(user => (user.fname.includes(search) || (user.corporate_email!=null && user.corporate_email.includes(search)) || user.email.includes(search)) );
    // //   console.log("sub",subArr);
    //   setUsers(subArr);
    //     // callAPI(search);

    // }



    // const detailFaq = async (id) => {
    //     let res = await DetailFaq(id);
    //     setFaqDetail({
    //         question: res.data.question,
    //         answer: res.data.answer
    //     })
    //     setVisible(true)
    //     console.log(res)
    // }

    return (
        <>
            <AdminBreadcrumb links={adminBreadcrumbLinks} />
            <CCard className="mb-4">
                <CCardBody>
                    <CRow>
                        <CCol sm={4}>
                            <h3 className="card-title mb-3">
                                Content Management
                            </h3>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm={3}>

                        </CCol>
                        {/* Select box */}
                        <CCol sm={3}>

                        </CCol>
                        <CCol sm={6} className="d-none d-md-block" >
                            {/* <Link to='/gallery/create'>     
                        <CButton className='float-end text-white' color="info" >
                        <i className="bi bi-plus-circle me-2"></i>
                            Add Content</CButton>
                    </Link> */}
                        </CCol>
                    </CRow><br />
                    {/* <MainChart /> */}
                    <CRow
                        xs={{ cols: 1, gutter: 4 }}
                        sm={{ cols: 2 }}
                        lg={{ cols: 4 }}
                        xl={{ cols: 5 }}
                        className="mb-2 text-center"
                    >
                        <CTable striped className=''>
                            <CTableHead>
                                <CTableRow>
                                    <CTableHeaderCell scope="col">S.NO</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Page Name</CTableHeaderCell>
                                    <CTableHeaderCell scope="col">Page Body</CTableHeaderCell>
                                    {/* <CTableHeaderCell scope="col">Photos</CTableHeaderCell> */}
                                    <CTableHeaderCell scope="col">Action</CTableHeaderCell>

                                </CTableRow>
                            </CTableHead>
                            <CTableBody>
                                {pages.length === 0 ? (
                                    <tr>
                                        <td colSpan="6">No data found</td>
                                    </tr>
                                ) : (
                                    pages.map((entry, index) => (
                                        <CTableRow>
                                            <CTableHeaderCell key={index}>{index + 1}</CTableHeaderCell>
                                            <CTableDataCell key={index}>{entry.page_name}</CTableDataCell>

                                            <CTableDataCell key={index}>{truncateText(stripHtml(entry.page_body), 8)} </CTableDataCell>
                                            <CTableDataCell key={index}>
                                                <div className='d-flex justify-content-center'>
                                                    <Link to={entry.page_name.includes('terms_and_condition') ? '/terms&condition' : '/privacy&policy'}>
                                                        <CButton className='mx-2 bi bi-eye-fill text-white' color="primary"></CButton>
                                                    </Link>
                                                    <Link to={`/content_management/edit?id=${entry.id}`}>
                                                        <CButton className="bi bi-pencil text-white" color="warning"></CButton>
                                                    </Link>

                                                </div>
                                            </CTableDataCell>

                                        </CTableRow>
                                    ))
                                )}
                            </CTableBody>
                        </CTable>
                    </CRow>
                </CCardBody>
            </CCard>


        </>
    )
}
export default Faq;